var mg = require('./metricsgraphics.js')
require('./metricsgraphics-dark.css')

exports.default = mg



//////////////////
// WEBPACK FOOTER
// ./vendor/metrics-graphics/index.js
// module id = 1061
// module chunks = 0